import { useCallback, useRef } from 'react';
import { log } from 'log';

import { useFavoritesTracking } from 'js/components/common/Game/FavoriteIcon/hooks/useFavoritesTracking';
import { useUpdateFavorites } from 'js/components/common/Game/FavoriteIcon/hooks/useUpdateFavorites';
import { changeFavorite } from 'js/components/system/App/hooks/useFavorites';

export const useOnFavouriteClick = ({ code, isFavorite }) => {
    const updateFavoriteGames = useUpdateFavorites({ code });
    const trackAPIEvent = useFavoritesTracking({ gameCode: code, isFavorite });
    const inProgress = useRef(false);

    return useCallback(async (event) => {
        event.stopPropagation();

        // prevent double-click
        if (inProgress.current) {
            return;
        }

        inProgress.current = true;

        trackAPIEvent();

        try {
            const value = !isFavorite;

            await changeFavorite({ code, isFavorite: value });
            updateFavoriteGames(value);
        } catch (e) {
            log('error', e);
        } finally {
            inProgress.current = false;
        }

    }, [inProgress, updateFavoriteGames, code, isFavorite, trackAPIEvent]);
};
